<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
*{
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}
#app {
  padding: 0;
  margin: 0;
  width: 100%;
  height: auto;
  
}
</style>
